import { useMemo, useState } from 'react';
import { breadcrumb, childFolders, currentFolder, folderResources } from '../domain/resources';

// Where a view of the Online Resources library is, and what it shows there:
// the library page and the drawer's "Link an Online Resource" picker both
// browse the same tree the same way (#424).
//
// Everything shown is the core's answer (core/src/resources.rs) over the rows
// the provider holds: the breadcrumb from Home, the folders here, the files
// here. The folder this view is "in" is read through `currentFolder`, so a
// folder another device deleted while this one was looking at it becomes Home
// on the next snapshot rather than an empty page with a breadcrumb naming a
// folder that is not there.
export default function useResourceBrowser({ folders = [], files = [] } = {}) {
  const [asked, setAsked] = useState(null);
  const here = useMemo(() => currentFolder(folders, asked), [folders, asked]);

  return useMemo(() => ({
    folderId: here,
    open: (folderId) => setAsked(folderId || null),
    crumbs: breadcrumb(folders, here),
    folders: childFolders(folders, here),
    files: folderResources(folders, files, here),
    // Home with nothing in the whole library, as against a folder with
    // nothing in it: two different empty states (`library_empty`,
    // `folder_empty`).
    libraryEmpty: folders.length === 0 && files.length === 0,
  }), [folders, files, here]);
}
